import {
  FETCH_KEG_COLLECTION_BOOKINGS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKINGS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKINGS_FAILURE,
  FETCH_KEG_COLLECTION_BOOKINGS_CLEAR,
  FETCH_KEG_COLLECTION_BOOKINGS_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
  FETCH_KEG_COLLECTION_BOOKINGS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKINGS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKINGS_FAILURE,
  FETCH_KEG_COLLECTION_BOOKINGS_CLEAR,
  FETCH_KEG_COLLECTION_BOOKINGS_QUEUE
)
